/* eslint-disable require-jsdoc */
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useAuth from 'src/shared-components/Auth';

const SignOutPage = () => {
  const router = useRouter();
  const { signOut } = useAuth();
  useEffect(() => {
    signOut();
    router.replace('/signin');
  }, []);

  return <></>;
};

export default SignOutPage;
